<template>
    <v-list
      class="draggable-item"
    >
      <v-list-tile>
        <v-list-tile-action>
          <v-icon large>layers</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <strong>{{ cluster.name }}</strong>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <v-icon>label</v-icon>
            <span class="caption">{{ cluster.tag }}</span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <cluster-setting
          :items="cluster"
          :actions="actions"
          v-if="(cluster.beacons || []).length > 0"
        ></cluster-setting>
      </v-list-tile>
      <!-- Nested Clusters -->
      <v-list-tile
        v-for="nestedItem in cluster.nested"
        :key="nestedItem.id"
        class="draggable-item"
      >
        <v-list-tile-action>
          <v-icon large>layers</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            <strong>{{ nestedItem.name }}</strong>
          </v-list-tile-title>
          <v-list-tile-sub-title>
            <v-icon>label</v-icon>
            <span class="caption">{{ nestedItem.tag }}</span>
          </v-list-tile-sub-title>
        </v-list-tile-content>
        <cluster-setting
          :items="nestedItem"
          :actions="actions"
          v-if="(nestedItem.beacons || []).length > 0"
        ></cluster-setting>
      </v-list-tile>
    </v-list>
</template>

<script>
import ClusterSetting from "./ClusterSetting";

export default {
  props: ["cluster", "actions"],
  components: {
    ClusterSetting,
  },
};
</script>

<style>
</style>